export { default } from './applyFocus'
